import { FormattedMessage, useIntl } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategoryPeriod, IPomReportDataInfo, IPomReportDataSubCategoryDetailsPeriod, IPomReportSubCategoryData, IPomReportTotalSumItem } from '../util/DataModelInterface'
import parse from 'html-react-parser';
import { Fragment, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { formatFinNumber } from '../util/FormatDateUtil';

export interface IPomListProps {
  categories: IPomReportCategoryData[];
  reportPeriodData: IPomReportDataCategoryPeriod;
  reportInfoData: IPomReportDataInfo | IPomReportTotalSumItem;
  reportCatSumData: {[x: string]: IPomReportCategorySumItem};
  period: string;
  companyName: string;
  periodEnd?: string;
  summary?: boolean;
}

export const PomPeriodsList = (props: IPomListProps) => {
  const intl = useIntl();
  const lang = intl.locale;
  const [tableheadings2, setTableheadings2] = useState([] as any[]);
  const [link, setLink] = useState(false);

  const {categories, reportPeriodData, period, companyName, periodEnd } = props;

  const tableheadings=[{'label':'pricegroup', 'colspan': 1}, {'label':'period', 'colspan': 1}, {'label':'fin', 'colspan': 3}, {'label':'aland', 'colspan': 3}, {'label':'b2b', 'colspan': 3}];

  useEffect(() => {
    setLink(props.companyName === '');
    let pcsTxt = intl.formatMessage({id: 'unit.pieces'});
    setTableheadings2(
      [ '', '', {'label':'fin', 'symbol':'€'}, {'label':'fin', 'symbol':'kg'}, {'label':'fin', 'symbol': pcsTxt},
          {'label':'aland', 'symbol':'€'}, {'label':'aland', 'symbol':'kg'}, {'label':'aland', 'symbol': pcsTxt},
          {'label':'b2b', 'symbol':'€'}, {'label':'b2b', 'symbol':'kg'}, {'label':'b2b', 'symbol': pcsTxt}
      ]
    );
  }, [intl, props.companyName]);

  // "categories_period": {
  //   "19WEEE1": [
  //     {
  //       "code": "1101",
  //       "period": "2024-04-01",
  //       "amount_fin": 5555,
  //       "amount_aland": 0,
  //       "amount_b2b": 0,
  //       "eur_fin": 833.25,
  //       "eur_aland": 0,
  //       "eur_b2b": 0
  //     },

  const exportReport = (e: { preventDefault: () => void; } | undefined) => {
    e?.preventDefault();
    let reportJsonData = [] as any;

    categories.forEach((cat: IPomReportCategoryData) => {
      let code = cat.code;
      let catData = reportPeriodData[code];
      cat.subs.forEach((sub: IPomReportSubCategoryData, index: number) => {
        let subcategory = sub.code;
        catData?.filter(subData => subData.code === subcategory).forEach( (subData: IPomReportDataSubCategoryDetailsPeriod, index: number) => {
          let monthStr = subData?.period.split("-")[1];
          let yearStr = subData?.period.split("-")[0];
          let reportingPeriod = monthStr + "/" + yearStr;
          let row = {} as any;
          if (sub) {
            let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
            row[intl.formatMessage({id: 'report.header.pricegroup'})] = sub.code + " " + subName;
            row[intl.formatMessage({id: 'report.header.period'})] = reportingPeriod;
            if (sub.unit === "kg") {
              row[intl.formatMessage({id: 'report.header.fin.kg'})] = subData?.amount_fin ? subData.amount_fin : "";
              row[intl.formatMessage({id: 'report.header.fin.pc'})] = "";
              row[intl.formatMessage({id: 'report.header.aland.kg'})] = subData?.amount_aland ? subData.amount_aland : "";
              row[intl.formatMessage({id: 'report.header.aland.pc'})] = "";
              row[intl.formatMessage({id: 'report.header.b2b.kg'})] = subData?.amount_b2b ? subData.amount_b2b : "";
              row[intl.formatMessage({id: 'report.header.b2b.pc'})] = "";
            } else {
              row[intl.formatMessage({id: 'report.header.fin.kg'})] = "";
              row[intl.formatMessage({id: 'report.header.fin.pc'})] = subData?.amount_fin ? subData.amount_fin : "";
              row[intl.formatMessage({id: 'report.header.aland.kg'})] = "";
              row[intl.formatMessage({id: 'report.header.aland.pc'})] = subData?.amount_aland ? subData.amount_aland : "";
              row[intl.formatMessage({id: 'report.header.b2b.kg'})] = "";
              row[intl.formatMessage({id: 'report.header.b2b.pc'})] = subData?.amount_b2b ? subData.amount_b2b : "";
            }
            row[intl.formatMessage({id: 'report.header.sum'})] = subData ? subData.eur_fin + subData.eur_aland + subData.eur_b2b : "";
            reportJsonData.push(row);
          }
        });
      });
    });


    reportApi.exportReport(
    { header: companyName + period + (periodEnd ? "-" + periodEnd : ""),
      data: reportJsonData
    })
  }

  const getReportRows = (catData: IPomReportDataSubCategoryDetailsPeriod[], subInfo: IPomReportSubCategoryData) => {
    return catData.filter(sub => sub.code === subInfo.code).map( (sub: IPomReportDataSubCategoryDetailsPeriod, index: number) => {
      let monthStr = sub?.period.split("-")[1];
      let yearStr = sub?.period.split("-")[0];
      let reportingPeriod = monthStr + "/" + yearStr;
      let eur_fin = "";
      let amount_fin = "";
      let eur_al = "";
      let amount_al = "";
      let eur_b2b = "";
      let amount_b2b = "";

      if (sub.amount_fin)
          amount_fin = (typeof sub.amount_fin === 'number') ? formatFinNumber(sub.amount_fin) : sub.amount_fin;
      if (sub.amount_aland)
          amount_al = (typeof sub.amount_aland === 'number') ? formatFinNumber(sub.amount_aland) : sub.amount_aland;
      if (sub.amount_b2b)
          amount_b2b = (typeof sub.amount_b2b === 'number') ? formatFinNumber(sub.amount_b2b) : sub.amount_b2b;
      eur_fin = sub.eur_fin ? formatFinNumber(sub.eur_fin) : "";
      eur_al = sub.eur_aland ? formatFinNumber(sub.eur_aland) : "";
      eur_b2b = sub.eur_b2b ? formatFinNumber(sub.eur_b2b) : "";

      return (
          <tr key={index}>
            <td></td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.period'}) }</span></span>
              <span>{reportingPeriod}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span>€</span>
              <span>{eur_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span>kg</span>
              <span>{(subInfo.unit === "kg") && amount_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(subInfo.unit === "kpl") && amount_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span>€</span>
              <span>{eur_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span>kg</span>
              <span>{(subInfo.unit === "kg") && amount_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(subInfo.unit === "kpl") && amount_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span>€</span>
              <span>{eur_b2b}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span>kg</span>
              <span>{(subInfo.unit === "kg") && amount_b2b}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(subInfo.unit === "kpl") && amount_b2b}</span>
            </td>
          </tr>
      );
    })
  }

  const getReportSubs = (cat: IPomReportCategoryData) => {
    const subs = cat.subs;
    let catReportData = reportPeriodData[cat.code] as IPomReportDataSubCategoryDetailsPeriod[];
    return subs.map( (sub: IPomReportSubCategoryData, index: number) => {
      let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
      return (
        <Fragment key={cat.code + "_" + index}>
          <tr key={index}>
            <td colSpan={11}>
              <span className="column-label">{tableheadings[0].label}</span>
              { link &&
                <Nav.Link
                  as={NavLink}
                  to="/reportsAdmin/reportedPom"
                  state={{ periodStart: period, periodEnd: periodEnd, category: sub.code, name: subName }}
                  className={"btn btn-link"}>
                    <span>{sub.code} {subName}</span>
                </Nav.Link>
              }
              { !link && <span>{sub.code} {subName}</span> }
            </td>
          </tr>
          { catReportData && getReportRows(catReportData, sub) }
        </Fragment>
      );
    })
  }

  const getReportCategory = (cat: IPomReportCategoryData, catIndex: number) => {
    let title = lang === "fi-FI" ? parse(cat.name_fi) : (lang === "en-GB" ? parse(cat.name_en) : parse(cat.name_se));
    let catReportData = reportPeriodData[cat.code] as IPomReportDataSubCategoryDetailsPeriod[];
    if (props.summary && (!catReportData || catReportData.length === 0) ) {
      // Skip empty category, if summary only
      return null;
    }
    return (
      <Fragment key={catIndex}>
        <tr key={"row_" + catIndex}>
          <td colSpan={11} className="subheader">
            <span className="column-label">{tableheadings[0].label}</span>
            { link &&
              <Nav.Link
                as={NavLink}
                to="/reportsAdmin/reportedPom"
                state={{ periodStart: period, periodEnd: periodEnd, category: cat.code, name: title }}
                className={"btn btn-link"}>
                  <span>{cat.view_code} {title}</span>
              </Nav.Link>
            }
            { !link && <span>{cat.view_code} {title}</span> }
          </td>
        </tr>
        { getReportSubs(cat) }
      </Fragment>
    )
  }

  return (
    <>
      { !props.summary &&
      <div className="toolbar">
        <button className="btn btn-primary" onClick={(e) => exportReport(e)}>
          <i className="fa fa-download me-2"></i>
          <FormattedMessage id="button.report.download"/>
        </button>
      </div>
      }

      <div id="reportlist">
        <div className="table-responsive ">
          <table className="table table-hover border-bottom ">
            <caption className="sr-only">WEEE reportdata</caption>
            <thead>
              <tr>
                {tableheadings.map( (th, index:number) => (
                    <th key={index} colSpan={th.colspan}>
                        <FormattedMessage id={`report.header.${th.label}`}/>
                    </th>
                ))}
              </tr>
              <tr>
                {tableheadings2.map( (symbolObj: any, index:number) => (
                    <th key={index}>
                        <span className="sr-only">{symbolObj.label}</span>
                        {symbolObj.symbol}
                    </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 && categories.map( (cat: IPomReportCategoryData, catIndex: number) => (
                getReportCategory(cat, catIndex)
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};